export default "__VITE_ASSET__3117ccf4__"